import { NeoReport, Report } from "@singularsystems/neo-reporting";
import React from 'react';
import { Layout } from '@singularsystems/neo-canvas-grid';
import InstrumentDetailsReportCriteria from "./InstrumentDetailsReportCriteria"
import { MaintenanceReportCategories } from "../MaintenanceReportCategories";
import { AppService, Types } from "../../../App/Services/AppService";
import { Neo } from "@singularsystems/neo-react";
import { TextConstants } from "../../../Common/TextConstants";

@NeoReport("InstrumentDetails", { category: MaintenanceReportCategories.DataExtractReports })
export default class InstrumentDetailsReport extends Report<InstrumentDetailsReportCriteria> {

    constructor(public instrumentTypesApiClient = AppService.get(Types.ApiClients.InstrumentTypeApiClient)) {
        super(InstrumentDetailsReportCriteria);
    }

    public renderCriteria() {
        return <>
            <Neo.GridLayout lg={4}>
                <Neo.FormGroup
                    label={TextConstants.Labels.InstrumentTypeName}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.instrumentTypesApiClient.getInstrumentTypeListFromCriteria}
                        bind={this.criteria.meta.instrumentTypeName}
                        bindDisplay={this.criteria.meta.instrumentTypeName}
                        displayMember={"staticInstrumentTypeName"}
                        items={this.instrumentTypesApiClient.getInstrumentTypeListFromCriteria(" ").then((arr) => arr.data.slice(0, 10)
                            .sort((x, y) => x.staticInstrumentTypeName.localeCompare(y.staticInstrumentTypeName)))}
                    />
                </Neo.FormGroup>

                <Neo.FormGroup
                    label={TextConstants.Labels.InstrumentSubTypeName}>
                    <Neo.AutoCompleteDropDown
                        itemSource={(searchCriteria) => this.criteria.meta.instrumentTypeName.value === undefined ? this.instrumentTypesApiClient.getInstrumentSubTypeListFromCriteriaAndTypeName(searchCriteria) :
                            this.instrumentTypesApiClient.getInstrumentSubTypeListFromCriteriaAndTypeName(searchCriteria, this.criteria.meta.instrumentTypeName.value!)}
                        bind={this.criteria.meta.instrumentSubType}
                        bindDisplay={this.criteria.meta.instrumentSubType}
                        items={this.instrumentTypesApiClient.getInstrumentSubTypeListFromCriteriaAndTypeName(" ", this.criteria.meta.instrumentTypeName.value!).then((arr) => arr.data.slice(0, 10)
                            .sort((x, y) => x.instrumentSubTypeName.localeCompare(y.instrumentSubTypeName)))}
                    />
                </Neo.FormGroup>
            </Neo.GridLayout>
        </>
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}